import { useState, useEffect } from "react";

export type UserRole = "buyer" | "seller" | "influencer";

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  avatar: string;
  verified: boolean;
  platform?: string;
  followers?: string;
  storeName?: string;
}

const AUTH_KEY = "sbp_auth_user";

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(() => {
    try {
      const stored = localStorage.getItem(AUTH_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = (userData: AuthUser) => {
    localStorage.setItem(AUTH_KEY, JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem(AUTH_KEY);
    setUser(null);
  };

  const updateUser = (updates: Partial<AuthUser>) => {
    if (!user) return;
    const updated = { ...user, ...updates };
    localStorage.setItem(AUTH_KEY, JSON.stringify(updated));
    setUser(updated);
  };

  return { user, login, logout, updateUser, isLoggedIn: !!user };
}
